<template>
    <div>
        <h3 class="mb-0">
            <div class="badge badge-primary" v-if="offer.roomQuantity">
                {{ offer.roomQuantity }}x
            </div>
            {{ $t(roomDetails(offer).room_type.type) }}
        </h3>
        <!-- <p>{{ offer.room.description.text }}</p> -->
        <div class="mb-1">
            {{ roomDetails(offer).number_of_beds }} {{ $t(roomDetails(offer).bed_type.type) }} {{ $tc('bed', roomDetails(offer).number_of_beds) }}
        </div>
        <template v-if="roomDetails(offer).accessible">
            <div class="highlight">Accessible room</div>
        </template>
        <BoardType :offer="offer" />
        <PolicyType :offer="offer" :showCancellationDate="showCancellationDate" />
        <!--
            <pre>
                {{ offer.price.taxes }}
            </pre>
        -->
    </div>
</template>

<script>
    import BoardType from '@/components/ui/BoardType'
    import PolicyType from '@/components/ui/PolicyType'

    export default {
        name: 'Room',
        props: ['offer', 'showCancellationDate'],
        components: {
            BoardType,
            PolicyType
        },
        data () {
            return {
                room_type_mapping: {
                    'A': {
                        'type': 'SUPERIOR_ROOM',
                        'desr': 'ROOM_WITH_BATH',
                    },
                    'B': {
                        'type': 'MODERATE_ROOM',
                        'desr': 'ROOM_WITH_BATH',
                    },
                    'C': {
                        'type': 'STANDARD_ROOM',
                        'desr': 'ROOM_WITH_BATH',
                    },
                    'D': {
                        'type': 'MINIMUM_ROOM',
                        'desr': 'ROOM_WITH_BATH',
                    },
                    'E': {
                        'type': 'SUPERIOR_ROOM',
                        'desr': 'ROOM_WITH_SHOWER',
                    },
                    'F': {
                        'type': 'MODERATE_ROOM',
                        'desr': 'ROOM_WITH_SHOWER',
                    },
                    'G': {
                        'type': 'STANDARD_ROOM',
                        'desr': 'ROOM_WITH_SHOWER',
                    },
                    'H': {
                        'type': 'MINIMUM_ROOM',
                        'desr': 'ROOM_WITH_SHOWER',
                    },
                    'I': {
                        'type': 'SUPERIOR_ROOM',
                        'desr': 'ROOM_WITHOUT_BATH_SHOWER',
                    },
                    'J': {
                        'type': 'MODERATE_ROOM',
                        'desr': 'ROOM_WITHOUT_BATH_SHOWER',
                    },
                    'K': {
                        'type': 'STANDARD_ROOM',
                        'desr': 'ROOM_WITHOUT_BATH_SHOWER',
                    },
                    'N': {
                        'type': 'NON_SMOKING_ROOM',
                        'desr': '',
                    },
                    'P': {
                        'type': 'EXECUTIVE_SUITE',
                        'desr': '',
                    },
                    'S': {
                        'type': 'SUITE',
                        'desr': '',
                    },
                    'T': {
                        'type': 'SUITE',
                        'desr': '',
                    },
                    'U': {
                        'type': 'SUITE',
                        'desr': '',
                    },
                    'W': {
                        'type': 'ROOM_AT_WEEKEND_RATE',
                        'desr': '',
                    },
                    '*': {
                        'type': 'RUN_OF_HOUSE_ROOM',
                        'desr': '',
                    },
                },
                bed_type_mapping: {
                    'T': {
                        'type': 'TWIN',
                        'persons': 2,
                    },
                    'S': {
                        'type': 'SINGLE',
                        'persons': 1,
                    },
                    'D': {
                        'type': 'DOUBLE',
                        'persons': 2,
                    },
                    'K': {
                        'type': 'KING',
                        'persons': 2,
                    },
                    'Q': {
                        'type': 'QUEEN',
                        'persons': 2,
                    },
                    'W': {
                        'type': 'WATER',
                        'persons': 2,
                    },
                    'P': {
                        'type': 'PULL-OUT',
                        'persons': 1,
                    },
                    '*': {
                        'type': 'RUN_OF_HOUSE_BED',
                        'persons': 1,
                    },
                },
            }
        },
        methods: {
            roomDetails: function(offer) {
                var type = offer.room.type;
                var typeEstimated = offer.room.typeEstimated;

                var run_of_house = false
                var room_type = {
                    'type': 'RUN_OF_HOUSE_ROOM',
                    'desr': '',
                }
                var number_of_beds = 1
                var bed_type = {
                    'type': 'RUN_OF_HOUSE_BED',
                    'persons': offer.guests.adults,
                }
                var accessible = false;

                if (typeEstimated !== undefined) {

                    if (typeEstimated.category == 'ACCESSIBLE_ROOM') {
                        accessible = true;
                    }

                    if (typeEstimated.category !== undefined) {
                        room_type = {
                            'type': typeEstimated.category,
                            'desr': '',
                        }
                    }

                    if (typeEstimated.beds !== undefined) {
                        number_of_beds =  typeEstimated.beds
                    }

                    if (
                        typeEstimated.bedType !== undefined
                    ) {
                        if (this.bed_type_mapping[typeEstimated.bedType[0]] !== undefined) {
                            bed_type = this.bed_type_mapping[typeEstimated.bedType[0]];
                        } else {
                            bed_type = {
                                'type': typeEstimated.bedType,
                                'persons': offer.guests.adults,
                            }
                        }
                    }
                }

                if (type !== undefined) {
                    // ROH: Run of the House
                    if (type == 'ROH') {
                        run_of_house = true
                    } else {
                        if (
                            type[0] !== undefined && 
                            type[1] !== undefined && 
                            (this.isNumeric(type[1]) || type[1] == '*') &&
                            type[2] !== undefined &&
                            this.room_type_mapping[type[0]] !== undefined &&
                            this.bed_type_mapping[type[2]] !== undefined
                        ) {
                            var room = type[0];
                            var number = type[1];
                            var bed = type[2];

                            if (number == '*' && number_of_beds <= 1) {
                                number = 1;
                            }
                            
                            room_type = this.room_type_mapping[room];
                            number_of_beds = number;
                            bed_type = this.bed_type_mapping[bed];
                        }
                    }
                }

                return {
                    'room_type': room_type,
                    'number_of_beds': number_of_beds,
                    'bed_type': bed_type,
                    'accessible': accessible,
                    'run_of_house': run_of_house,
                };
            },
            isNumeric: function(n) {
                return !isNaN(parseFloat(n)) && isFinite(n);
            },
        },
        i18n: { // `i18n` option, setup locale info for component
            messages: {
                en: {
                    bed: 'bed | beds',
                }
            },
        }
    }
</script>

<style scoped>
    .highlight{
        color:#066706;
    }
</style>